var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{ref:"baseForm",staticClass:"d-level-editor-container z-draggable-editor",attrs:{"showSubmitButton":false,"form":_vm.value,"formItems":_vm.getFormItems,"labelWidth":_vm.labelWidth,"rules":_vm.rules,"options":{
    memberLevelOptions: _vm.memberLevelOptions
  },"popperAppendToBody":false}})}
var staticRenderFns = []

export { render, staticRenderFns }